import React, { useEffect, useState } from 'react';
import Loader from './Loader';
import { Container } from 'react-bootstrap';
import { alertModal } from '../utils/modalController';
import { Link, useNavigate } from 'react-router-dom';
import { fetchAuth } from '../utils/fetchAuth';

interface Props {
    pacienteId: string;
    consultaId?: string;
}

const apiUrl = process.env.REACT_APP_API_URL || '';

const EditConsultPlanoAlimentar: React.FC<Props> = ({ pacienteId, consultaId }) => {
    const [planoAlimentar, setPlanoAlimentar] = useState<PlanoAlimentar | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [creatingPlano, setCreatingPlano] = useState<boolean>(false);

    const navigate = useNavigate();

    useEffect(() => {
        const buscarPlanoAlimentar = async () => {
            try {
                const response = await fetchAuth(`${apiUrl}/consultorio/planos-alimentares?consulta=${consultaId}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
                if (!response.ok) {
                    const error_json = await response.json();
                    throw new Error(error_json.message || "Erro desconhecido");
                }
                const data = await response.json();
                setPlanoAlimentar(data);
            } catch (e) {
                console.error('Erro ao buscar planos:', e);
            } finally {
                setLoading(false);
            }
        };

        buscarPlanoAlimentar();
    }, [pacienteId, consultaId]);

    if (loading) return <Loader />;

    return (
        <>
            <Container>
                <h5 className="mb-3">Plano Alimentar</h5>
                {planoAlimentar ? (
                    <Link
                        to={`/consultorio/pacientes/${pacienteId}/planos-alimentares/${planoAlimentar.id}?consulta=${consultaId}`}
                    >Editar plano alimentar</Link>
                ) : (
                    <a
                        href="#"
                        onClick={async (e) => {
                            e.preventDefault();
                            if (creatingPlano) return;
                            setCreatingPlano(true);

                            fetchAuth(`${apiUrl}/consultorio/planos-alimentares`, {
                                method: 'POST',
                                body: JSON.stringify({ 'patient-id': pacienteId, 'consulta-id': consultaId }),
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                            })
                                .then(async (res) => {
                                    if (!res.ok) {
                                        const error_json = await res.json();
                                        throw new Error(error_json.message || 'Erro ao criar plano alimentar');
                                    }
                                    return res.json();
                                })
                                .then(data => {
                                    navigate(`/consultorio/pacientes/${pacienteId}/planos-alimentares/${data.id}?consulta=${consultaId}`);
                                })
                                .catch(err => {
                                    throw new Error('Erro ao criar plano alimentar: ' + err);
                                })
                                .finally(() => {
                                    setCreatingPlano(false);
                                });
                        }}
                    >{creatingPlano ? 'Criando plano alimentar...' : 'Criar plano alimentar'}</a>
                )}
            </Container>
        </>
    );
};

export default EditConsultPlanoAlimentar;
